import * as types from './types'

export const actions = {
	getDictValuesAction: (payload) => ({
		type: types.GET_DICT_VALUES,
	}),

	getDictValuesActionDone: (payload) => ({
		type: types.GET_DICT_VALUES_DONE,
		payload,
	}),

	getDictValuesActionFail: (payload) => ({
		type: types.GET_DICT_VALUES_FAIL,
	}),


	getDictNominationAction: (payload) => ({
		type: types.GET_DICT_NOMINATION,
	}),

	getDictNominationActionDone: (payload) => ({
		type: types.GET_DICT_NOMINATION_DONE,
		payload,
	}),

	getDictNominationActionFail: (payload) => ({
		type: types.GET_DICT_NOMINATION_FAIL,
	}),


	getDictParamsAction: (payload) => ({
		type: types.GET_DICT_PARAMS,
	}),

	getDictParamsActionDone: (payload) => ({
		type: types.GET_DICT_PARAMS_DONE,
		payload,
	}),

	getDictParamsActionFail: (payload) => ({
		type: types.GET_DICT_PARAMS_FAIL,
	}),


	setEmplSignAction: (payload) => ({
		type: types.SET_EMPL_SIGN,
	}),

	setEmplSignActionDone: (payload) => ({
		type: types.SET_EMPL_SIGN_DONE,
		payload,
	}),

	setEmplSignActionFail: (payload) => ({
		type: types.SET_EMPL_SIGN_FAIL,
	}),


	setEmplXmlAction: (payload) => ({
		type: types.SET_EMPL_XML,
	}),

	setEmplXmlActionDone: (payload) => ({
		type: types.SET_EMPL_XML_DONE,
		payload,
	}),

	setEmplXmlActionFail: (payload) => ({
		type: types.SET_EMPL_XML_FAIL,
	}),


	getEmplListAction: (payload) => ({
		type: types.GET_EMPL_LIST,
	}),

	getEmplListActionDone: (payload) => ({
		type: types.GET_EMPL_LIST_DONE,
		payload,
	}),

	getEmplListActionFail: (payload) => ({
		type: types.GET_EMPL_LIST_FAIL,
	}),


	getMioCheckUserAction: (payload) => ({
		type: types.GET_MIO_CHECK_USER,
	}),

	getMioCheckUserActionDone: (payload) => ({
		type: types.GET_MIO_CHECK_USER_DONE,
		payload,
	}),

	getMioCheckUserActionFail: (payload) => ({
		type: types.GET_MIO_CHECK_USER_FAIL,
	}),


	getMioByIdAction: (payload) => ({
		type: types.GET_MIO_BY_ID,
	}),

	getMioByIdActionDone: (payload) => ({
		type: types.GET_MIO_BY_ID_DONE,
		payload,
	}),

	getMioByIdActionFail: (payload) => ({
		type: types.GET_MIO_BY_ID_FAIL,
	}),


	getMioListAction: (payload) => ({
		type: types.GET_MIO_LIST,
	}),

	getMioListActionDone: (payload) => ({
		type: types.GET_MIO_LIST_DONE,
		payload,
	}),

	getMioListActionFail: (payload) => ({
		type: types.GET_MIO_LIST_FAIL,
	}),


	setMioRowAction: (payload) => ({
		type: types.SET_MIO_ROW,
	}),

	setMioRowActionDone: (payload) => ({
		type: types.SET_MIO_ROW_DONE,
		payload,
	}),

	setMioRowActionFail: (payload) => ({
		type: types.SET_MIO_ROW_FAIL,
	}),


	setMioXmlAction: (payload) => ({
		type: types.SET_MIO_XML,
	}),

	setMioXmlActionDone: (payload) => ({
		type: types.SET_MIO_XML_DONE,
		payload,
	}),

	setMioXmlActionFail: (payload) => ({
		type: types.SET_MIO_XML_FAIL,
	}),


	setMioSignAction: (payload) => ({
		type: types.SET_MIO_SIGN,
	}),

	setMioSignActionDone: (payload) => ({
		type: types.SET_MIO_SIGN_DONE,
		payload,
	}),

	setMioSignActionFail: (payload) => ({
		type: types.SET_MIO_SIGN_FAIL,
	}),


	setMioReportAction: (payload) => ({
		type: types.SET_MIO_REPORT,
	}),

	setMioReportActionDone: (payload) => ({
		type: types.SET_MIO_REPORT_DONE,
		payload,
	}),

	setMioReportActionFail: (payload) => ({
		type: types.SET_MIO_REPORT_FAIL,
	}),


	getMioReportAction: (payload) => ({
		type: types.GET_MIO_REPORT,
	}),

	getMioReportActionDone: (payload) => ({
		type: types.GET_MIO_REPORT_DONE,
		payload,
	}),

	getMioReportActionFail: (payload) => ({
		type: types.GET_MIO_REPORT_FAIL,
	}),


	getDtspMioListAction: (payload) => ({
		type: types.GET_DTSP_MIO_LIST,
	}),

	getDtspMioListActionDone: (payload) => ({
		type: types.GET_DTSP_MIO_LIST_DONE,
		payload,
	}),

	getDtspMioListActionFail: (payload) => ({
		type: types.GET_DTSP_MIO_LIST_FAIL,
	}),


	getDtspReportListAction: (payload) => ({
		type: types.GET_DTSP_REPORT_LIST,
	}),

	getDtspReportListActionDone: (payload) => ({
		type: types.GET_DTSP_REPORT_LIST_DONE,
		payload,
	}),

	getDtspReportListActionFail: (payload) => ({
		type: types.GET_DTSP_REPORT_LIST_FAIL,
	}),


	setDtspReportSignAction: (payload) => ({
		type: types.SET_DTSP_REPORT_SIGN,
	}),

	setDtspReportSignActionDone: (payload) => ({
		type: types.SET_DTSP_REPORT_SIGN_DONE,
		payload,
	}),

	setDtspReportSignActionFail: (payload) => ({
		type: types.SET_DTSP_REPORT_SIGN_FAIL,
	}),


	setDtspReportXmlAction: (payload) => ({
		type: types.SET_DTSP_REPORT_XML,
	}),

	setDtspReportXmlActionDone: (payload) => ({
		type: types.SET_DTSP_REPORT_XML_DONE,
		payload,
	}),

	setDtspReportXmlActionFail: (payload) => ({
		type: types.SET_DTSP_REPORT_XML_FAIL,
	}),


	setDtspReqsListAction: (payload) => ({
		type: types.SET_DTSP_REQS_LIST,
	}),

	setDtspReqsListActionDone: (payload) => ({
		type: types.SET_DTSP_REQS_LIST_DONE,
		payload,
	}),

	setDtspReqsListActionFail: (payload) => ({
		type: types.SET_DTSP_REQS_LIST_FAIL,
	}),


	getDtspReqsOneAction: (payload) => ({
		type: types.GET_DTSP_REQS_ONE,
	}),

	getDtspReqsOneActionDone: (payload) => ({
		type: types.GET_DTSP_REQS_ONE_DONE,
		payload,
	}),

	getDtspReqsOneActionFail: (payload) => ({
		type: types.GET_DTSP_REQS_ONE_FAIL,
	}),


	getDtspReqsPageAction: (payload) => ({
		type: types.GET_DTSP_REQS_PAGE,
	}),

	getDtspReqsPageActionDone: (payload) => ({
		type: types.GET_DTSP_REQS_PAGE_DONE,
		payload,
	}),

	getDtspReqsPageActionFail: (payload) => ({
		type: types.GET_DTSP_REQS_PAGE_FAIL,
	}),
}
